/*
	Skin
*/

/*
	Favicon (without extension)
*/
const favicon 		= 'favicon.ico'

/*
	Configs gerais para essa skin
*/
const title 		= 'Cartório de Sobradinho - 2º Ofício'
const authority 	= "https://pee.sts-login.sobradinhodigital.com.br"
const client_id 	= "cartorio-jk"

/*
	Theme
	IMPORTANTE: Isso será um dynamic import
	Usar path relativo ao ./src/plugins/skins e usar extensão
*/
const cssTheme 		= 'theme.css'

/*
	Exportando
*/
export default {
	title,
	authority,
	client_id,
	cssTheme,
	favicon
}